import { createRouter, createWebHashHistory } from "vue-router";
import store from "../store";
import { routes } from "../lib/routes";
import { isAuthorizedForPermissions } from "../lib/auth";

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
});

router.beforeEach((to, _from, next) => {
    const isAuthenticated = store.getters.isAuthenticated;
    if (!isAuthenticated && to.name !== "Home") {
        next({ name: "Home" });
    } else {
        const permissions = to.meta.permissions;
        if (permissions) {
            const authUser = store.state.authUser;
            if (isAuthorizedForPermissions(permissions, authUser)) {
                next();
            } else {
                next({ name: "NotFound" });
            }
        } else {
            next();
        }
    }
});

router.beforeEach((_to, _from, next) => {
    if (store.getters.getGlobalSearch) {
        store.commit("clearGlobalSearch");
    }
    if (store.getters.isNavigationWarningEnabled) {
        if (confirm("You have unsaved changes! Are you sure you want to leave?")) {
            store.commit("clearNavigationWarning");
            next();
        }
    } else {
        next();
    }
});

export default router;
